import React from 'react';
import IMsgExpandTextsFP from '../FullPagesComponents/Interaction/IMsgExpandTextsFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';

//= ========================================================================

const IMsgExpandTextsDF = ({
  globJSON,
  simPlatform,
  slideshowRefs = null,
}) => (
  <SimulatorsViewerArrangement>
    <IMsgExpandTextsFP
      globJSON={globJSON}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
    />
  </SimulatorsViewerArrangement>
);

export default IMsgExpandTextsDF;
